import { render } from "./LoyaltyDialog.vue?vue&type=template&id=4482a0b5"
import script from "./LoyaltyDialog.vue?vue&type=script&lang=js"
export * from "./LoyaltyDialog.vue?vue&type=script&lang=js"

import "./LoyaltyDialog.vue?vue&type=style&index=0&id=4482a0b5&lang=scss"
script.render = render

export default script